import axios from 'axios';

const apiUrl = 'api/sensor-data';

export const getAddress = (lat: string | number, lon: string | number) => {
  const requestUrl = `${apiUrl}/truck/position/geocoding?lat=${lat}&lon=${lon}`;
  return axios.get(requestUrl);
};
